import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2280502"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification-content" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "name-row" }
const _hoisted_4 = { class: "name-row-inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name-text" }, "Name", -1))
const _hoisted_6 = { class: "name-input" }
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, " You will receive a push notification when a response meets the below criteria ", -1))
const _hoisted_9 = { class: "filters-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "group-title" }, "General Filters", -1))
const _hoisted_11 = { class: "filters" }
const _hoisted_12 = { class: "row-content" }
const _hoisted_13 = { class: "name-text" }
const _hoisted_14 = { class: "selected" }
const _hoisted_15 = {
  key: 0,
  class: "group-title"
}
const _hoisted_16 = { class: "filters" }
const _hoisted_17 = { class: "row-content" }
const _hoisted_18 = { class: "name-text" }
const _hoisted_19 = { class: "selected" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_MenuRow = _resolveComponent("MenuRow")!
  const _component_SimpleSpinner = _resolveComponent("SimpleSpinner")!
  const _component_WebViewScreen = _resolveComponent("WebViewScreen")!

  return (_openBlock(), _createBlock(_component_WebViewScreen, {
    class: "add-notification-container",
    "no-pad": "",
    title: "New Notification"
  }, {
    "left-button": _withCtx(() => [
      _createVNode(_component_BackButton)
    ]),
    "right-button": _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass({ canSave: _ctx.canSave }),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCreateNotificationSetting && _ctx.onCreateNotificationSetting(...args)))
      }, " Done ", 2)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("input", {
                  type: "text",
                  placeholder: "New Notification",
                  value: _ctx.newFilterName,
                  onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateName && _ctx.updateName(...args)))
                }, null, 40, _hoisted_7)
              ])
            ])
          ]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generalFilters, (filterSetting) => {
              return (_openBlock(), _createBlock(_component_MenuRow, {
                key: filterSetting.value,
                square: "",
                "menu-item": {
                            icon: '',
                            name: filterSetting.label,
                            id: filterSetting.value,
                        },
                onClick: _ctx.onSelectLeaderboard
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(filterSetting.label), 1),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.newFilterValues[filterSetting.value] || ''), 1)
                  ])
                ], undefined, true),
                _: 2
              }, 1032, ["menu-item", "onClick"]))
            }), 128))
          ]),
          (
                        !_ctx.customFieldValuesLastRefreshed ||
                        _ctx.customFieldValues.length
                    )
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Custom Filters "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            (
                            _ctx.customFieldValuesLastRefreshed ||
                            _ctx.customFieldValues.length
                        )
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.customFieldValues, (filterSetting) => {
                  return (_openBlock(), _createBlock(_component_MenuRow, {
                    key: filterSetting.value,
                    square: "",
                    "menu-item": {
                                icon: '',
                                name: filterSetting.label,
                                id: filterSetting.value,
                            },
                    onClick: _ctx.onSelectLeaderboard
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(filterSetting.label), 1),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.newFilterValues[filterSetting.value] ||
                                        ''), 1)
                      ])
                    ], undefined, true),
                    _: 2
                  }, 1032, ["menu-item", "onClick"]))
                }), 128))
              : (_openBlock(), _createBlock(_component_SimpleSpinner, {
                  key: 1,
                  size: "small",
                  class: "spinner",
                  "line-fg-color": "#B43DC6"
                }))
          ])
        ])
      ])
    ], undefined, true),
    _: 1
  }))
}